module.exports = __webpack_public_path__ + "files/233269bd9eec7db0cc37357ab5be3b08.png";